/** Turns a title into the kebab-case name a knowledge file is stored under ("Weekly report" -> "weekly-report"). */
const toKnowledgeSlug = (title) => {
  const slug = String(title || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
    .replace(/-+$/g, '');

  return slug || 'untitled';
};

export default toKnowledgeSlug;
